import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import ClientFileBrowser from './ClientFileBrowser';
import ClientUploader from './ClientUploader';
import PowerBIViewer from './PowerBIViewer';
import TeamInvitation from './TeamInvitation';
import Settings from './Settings';
import './ClientPreview.css';

const ClientPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('files');

  const { clientCompany, previewMode } = location.state || {};

  if (!clientCompany || !previewMode) {
    navigate('/clients');
    return null;
  }

  const handleReturnToAdmin = () => {
    const adminContext = localStorage.getItem('adminContext');
    if (adminContext) {
      const { returnUrl } = JSON.parse(adminContext);
      localStorage.removeItem('adminContext');
      navigate(returnUrl);
    } else {
      navigate('/clients');
    }
  };

  const renderClientView = () => {
    switch (currentView) {
      case 'files':
        return <ClientFileBrowser company={clientCompany} />;
      case 'upload':
        return <ClientUploader company={clientCompany} />;
      case 'reports':
        return <PowerBIViewer user={{}} company={clientCompany} />;
      case 'team':
        return <TeamInvitation user={{}} company={clientCompany} />;
      case 'settings':
        return <Settings user={{}} company={clientCompany} />;
      default:
        return <ClientFileBrowser company={clientCompany} />;
    }
  };

  return (
    <div className="client-preview">
      {/* Admin Preview Banner */}
      <div className="preview-banner">
        <div className="banner-content">
          <div className="banner-info">
            <span className="preview-icon">👁️</span>
            <span className="preview-text">
              Previewing as <strong>{clientCompany.name}</strong> client
            </span>
          </div>
          <button
            className="return-admin-btn"
            onClick={handleReturnToAdmin}
          >
            ← Return to Admin
          </button>
        </div>
      </div>

      {/* Client Navigation */}
      <Navigation
        user={{
          attributes: {
            name: 'Preview User',
            email: 'preview@example.com'
          }
        }}
        company={clientCompany}
        signOut={() => {}} // No-op for preview
      />

      {/* Client View Selector */}
      <div className="preview-nav">
        <button
          className={`nav-btn ${currentView === 'files' ? 'active' : ''}`}
          onClick={() => setCurrentView('files')}
        >
          📁 Files
        </button>
        <button
          className={`nav-btn ${currentView === 'upload' ? 'active' : ''}`}
          onClick={() => setCurrentView('upload')}
        >
          📤 Upload Assets
        </button>
        <button
          className={`nav-btn ${currentView === 'reports' ? 'active' : ''}`}
          onClick={() => setCurrentView('reports')}
        >
          📈 Reports
        </button>
        <button
          className={`nav-btn ${currentView === 'team' ? 'active' : ''}`}
          onClick={() => setCurrentView('team')}
        >
          👥 Team
        </button>
        <button
          className={`nav-btn ${currentView === 'settings' ? 'active' : ''}`}
          onClick={() => setCurrentView('settings')}
        >
          ⚙️ Settings
        </button>
      </div>

      {/* Client Content */}
      <div className="preview-content">
        {renderClientView()}
      </div>
    </div>
  );
};

export default ClientPreview;